import { prazoDoPerfil, situacaoDoPrazo, type PrazoDoLaboratorio, type SituacaoDoPrazo } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";

/** Prazo do laboratório ativo (dias, dias úteis, sábado, aviso) — a mesma consulta do perfil que
 *  as telas já fazem, cacheada. */
export function usePrazoDoLaboratorio(): PrazoDoLaboratorio {
  return prazoDoPerfil(trpc.organization.getProfiles.useQuery().data?.labProfile);
}

/** Situação do prazo de um pedido em aberto; concluído, cancelado ou recusado não tem prazo a cumprir. */
export function situacaoDoPedido(
  order: { status: string; deadline?: Date | string | null; createdAt: Date | string },
  prazo: PrazoDoLaboratorio,
): SituacaoDoPrazo {
  if (["CONCLUIDO", "CANCELADO", "RECUSADO"].includes(order.status)) return "noPrazo";
  return situacaoDoPrazo(order, prazo);
}
